import { connect } from 'react-redux'
import ServiceProviders from '../../components/services/edit/ServiceProviders'
import { actionCreators, updateProviders } from '../../state/actions/services/index'
import { getProductsIdsByServiceId } from '../../state/reducers/provider-products/index'
import { IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  const serviceId = state.service.metadata.edit.serviceId
  return {
    serviceId,
    serviceProductsIds: getProductsIdsByServiceId(state, serviceId),
    formRef: ownProps.formRef,
    onStepSuccessfullyCompleted: ownProps.onStepSuccessfullyCompleted
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onSelectProvider: (providerId: string, serviceId: string) => {
      dispatch(actionCreators.selectProvider(providerId, serviceId))
    },
    onUpdateProviders: (serviceId: string, serviceProductsIds: string[]) => {
      return dispatch(updateProviders(serviceId, serviceProductsIds))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceProviders)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceProviders.ts